{
  "familyId": "TIJD-OMREKENEN",
  "questions": [
    {
      "id": "TIJD-OMREKENEN-001",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een kok moet een gerecht precies 3 uur laten sudderen. De timer op het fornuis werkt alleen in minuten. Hoeveel minuten moet hij instellen?",
      "options": ["180 minuten", "30 minuten", "300 minuten", "360 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_hours_to_minutes",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Uren naar minuten omrekenen",
            "content": "1 uur = 60 minuten. Vermenigvuldig het aantal uren met 60. 3 uur = 3 × 60 = 180 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De kok moet uren omrekenen naar minuten. Dat doe je door te vermenigvuldigen met 60, want 1 uur = 60 minuten. Dus 3 uur = 3 × 60 = 180 minuten. De kok stelt de timer in op 180 minuten. Controleer: 180 ÷ 60 = 3 uur ✓.",
        "solutionSteps": [
          "1 uur = 60 minuten",
          "3 uur = 3 × 60 = 180 minuten",
          "Controleer: 180 ÷ 60 = 3 uur ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 60 = 180 minuten.",
          "1": "30 minuten is een half uur, niet 3 uur. Je hebt waarschijnlijk 3 × 10 gerekend. Maar 1 uur = 60 minuten, niet 10. Reken: 3 × 60 = 180 minuten.",
          "2": "Je hebt 3 × 100 gerekend. Maar 1 uur = 60 minuten, niet 100. Onthoud: het 60-tallig stelsel — een uur heeft 60 minuten. Reken: 3 × 60 = 180.",
          "3": "360 minuten is 6 uur (6 × 60 = 360). Je hebt waarschijnlijk 3 × 60 dubbel geteld. Voor 3 uur reken je: 3 × 60 = 180 minuten."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-002",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een sportcoach zegt: 'De training duurde 240 minuten.' Hoeveel uur is dat?",
      "options": ["4 uur", "2 uur", "24 uur", "40 uur"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_hours",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Minuten naar uren omrekenen",
            "content": "Om minuten naar uren om te rekenen, deel je door 60. 240 ÷ 60 = 4 uur. Onthoud: uren → minuten = × 60, minuten → uren = ÷ 60.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om minuten naar uren om te rekenen, deel je door 60 (want 1 uur = 60 minuten). 240 ÷ 60 = 4 uur. De training duurde dus 4 uur. Controleer: 4 × 60 = 240 minuten ✓. Onthoud: van kleine eenheid naar grote eenheid = delen.",
        "solutionSteps": [
          "Minuten → uren: deel door 60",
          "240 ÷ 60 = 4 uur",
          "Controleer: 4 × 60 = 240 min ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 240 ÷ 60 = 4 uur.",
          "1": "2 uur = 120 minuten, niet 240. Je hebt waarschijnlijk 240 ÷ 120 = 2 gerekend. Maar je moet delen door 60 (minuten per uur): 240 ÷ 60 = 4 uur.",
          "2": "Je hebt de cijfers van 240 omgedraaid (24). Maar je moet rekenen: 240 ÷ 60 = 4 uur. 24 uur is een hele dag!",
          "3": "Je hebt 240 ÷ 6 gerekend in plaats van 240 ÷ 60. Let op het aantal nullen: 1 uur = 60 minuten, niet 6. Reken: 240 ÷ 60 = 4 uur."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-003",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Bij een hardloopwedstrijd wordt de tijd gemeten in seconden. Een loper finisht in 300 seconden. Hoeveel minuten is dat?",
      "options": ["5 minuten", "50 minuten", "3 minuten", "30 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_seconds_to_minutes",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Seconden naar minuten omrekenen",
            "content": "1 minuut = 60 seconden. Om seconden naar minuten om te rekenen, deel je door 60. 300 ÷ 60 = 5 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De loper finisht in 300 seconden. Om seconden naar minuten om te rekenen, deel je door 60 (want 1 minuut = 60 seconden). 300 ÷ 60 = 5 minuten. De loper deed er dus 5 minuten over. Controleer: 5 × 60 = 300 seconden ✓.",
        "solutionSteps": [
          "Seconden → minuten: deel door 60",
          "300 ÷ 60 = 5 minuten",
          "Controleer: 5 × 60 = 300 sec ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 300 ÷ 60 = 5 minuten.",
          "1": "Je hebt 300 ÷ 6 gerekend in plaats van 300 ÷ 60. Let op: 1 minuut = 60 seconden, niet 6. Reken: 300 ÷ 60 = 5 minuten.",
          "2": "Je hebt 300 ÷ 100 gerekend. Maar 1 minuut = 60 seconden, niet 100. Het 60-tallig stelsel is anders dan het tientallig stelsel. Reken: 300 ÷ 60 = 5.",
          "3": "Je hebt 300 ÷ 10 gerekend. Maar 1 minuut = 60 seconden, niet 10. Reken: 300 ÷ 60 = 5 minuten."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-004",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een scheidsrechter noteert dat de blessuretijd 420 seconden was. Hoeveel minuten is dat?",
      "options": ["7 minuten", "42 minuten", "4 minuten", "70 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_seconds_to_minutes_context",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Seconden naar minuten",
            "content": "Deel de seconden door 60. 420 ÷ 60 = 7 minuten. Tip: 7 × 60 = 420 ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De scheidsrechter wil weten hoeveel minuten 420 seconden is. Deel door 60: 420 ÷ 60 = 7 minuten. De blessuretijd was dus 7 minuten. Controleer: 7 × 60 = 420 seconden ✓.",
        "solutionSteps": [
          "Seconden → minuten: deel door 60",
          "420 ÷ 60 = 7 minuten",
          "Controleer: 7 × 60 = 420 sec ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 420 ÷ 60 = 7 minuten.",
          "1": "Je hebt 420 ÷ 10 gerekend. Maar 1 minuut = 60 seconden, niet 10. Reken: 420 ÷ 60 = 7 minuten.",
          "2": "4 minuten = 240 seconden (4 × 60 = 240), niet 420. Reken: 420 ÷ 60 = 7 minuten.",
          "3": "Je hebt 420 ÷ 6 gerekend in plaats van 420 ÷ 60. Let op het aantal nullen: 1 minuut = 60 seconden. Reken: 420 ÷ 60 = 7."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-005",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 2 uur en 30 minuten?",
      "options": ["150 minuten", "230 minuten", "90 minuten", "250 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_minutes",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar minuten",
            "content": "Reken de uren apart om: 2 uur = 2 × 60 = 120 minuten. Tel dan de losse minuten erbij: 120 + 30 = 150 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Reken stap voor stap. Eerst de uren: 2 uur = 2 × 60 = 120 minuten. Dan de losse minuten erbij: 120 + 30 = 150 minuten. Controleer: 150 ÷ 60 = 2 rest 30 → 2 uur 30 min ✓.",
        "solutionSteps": [
          "2 uur = 2 × 60 = 120 minuten",
          "120 + 30 = 150 minuten",
          "Controleer: 150 ÷ 60 = 2 rest 30 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × 60 + 30 = 120 + 30 = 150 minuten.",
          "1": "Je hebt de getallen aan elkaar gezet (2 en 30 = 230). Maar je moet rekenen: 2 × 60 + 30 = 150 minuten.",
          "2": "90 minuten is 1,5 uur. Je hebt maar 1 uur en 30 minuten gerekend. Het is 2 uur en 30 minuten: 2 × 60 + 30 = 150.",
          "3": "Je hebt 2 × 100 + 50 gerekend. Maar 1 uur = 60 minuten, niet 100. Reken: 2 × 60 + 30 = 150 minuten."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-006",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren en minuten zijn 195 minuten?",
      "options": ["3 uur en 15 minuten", "1 uur en 95 minuten", "19 uur en 5 minuten", "2 uur en 75 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_compound",
      "variantIndex": 6,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Minuten omzetten naar uren en minuten",
            "content": "Deel door 60 en kijk hoeveel hele uren erin passen. 195 ÷ 60 = 3 rest 15. Dus 3 uur en 15 minuten. Check: 3 × 60 = 180, en 195 − 180 = 15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om minuten om te zetten naar uren en minuten, deel je door 60. Hoeveel keer past 60 in 195? 3 × 60 = 180 (past). 4 × 60 = 240 (past niet). Dus 3 hele uren. Rest: 195 − 180 = 15 minuten. Antwoord: 3 uur en 15 minuten. Controleer: 3 × 60 + 15 = 195 ✓.",
        "solutionSteps": [
          "Deel door 60: hoeveel hele uren passen erin?",
          "3 × 60 = 180 (past), 4 × 60 = 240 (past niet)",
          "Rest: 195 − 180 = 15 minuten",
          "Antwoord: 3 uur en 15 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 60 = 180, rest = 195 − 180 = 15 minuten.",
          "1": "95 minuten is meer dan 1 uur! Je hebt maar 1 × 60 = 60 afgetrokken. Maar er passen 3 hele uren in 195 minuten: 3 × 60 = 180, rest = 15.",
          "2": "Je hebt de cijfers van 195 gesplitst (19 en 5). Maar je moet delen door 60: 195 ÷ 60 = 3 uur en 15 minuten.",
          "3": "75 minuten is meer dan 1 uur, dus '2 uur en 75 minuten' klopt niet. Je moet de minuten altijd onder 60 houden. 195 ÷ 60 = 3 uur rest 15 minuten."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-007",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel seconden zijn 3 minuten en 20 seconden?",
      "options": ["200 seconden", "320 seconden", "80 seconden", "140 seconden"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_seconds",
      "variantIndex": 7,
      "citoDifficulty": 0.41,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar seconden",
            "content": "Reken de minuten om: 3 minuten = 3 × 60 = 180 seconden. Tel de seconden erbij: 180 + 20 = 200 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Reken stap voor stap. Eerst de minuten: 3 minuten = 3 × 60 = 180 seconden. Dan de losse seconden erbij: 180 + 20 = 200 seconden. Controleer: 200 ÷ 60 = 3 rest 20 → 3 min 20 sec ✓.",
        "solutionSteps": [
          "3 minuten = 3 × 60 = 180 seconden",
          "180 + 20 = 200 seconden",
          "Controleer: 200 ÷ 60 = 3 rest 20 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 60 + 20 = 180 + 20 = 200 seconden.",
          "1": "Je hebt de getallen aan elkaar gezet (3 en 20 = 320). Maar je moet rekenen: 3 × 60 + 20 = 200 seconden.",
          "2": "Je hebt 3 × 20 = 60 + 20 = 80 gerekend. Maar 1 minuut = 60 seconden, niet 20. Reken: 3 × 60 + 20 = 200.",
          "3": "Je hebt 2 × 60 + 20 = 140 gerekend. Maar het zijn 3 minuten, niet 2. Reken: 3 × 60 + 20 = 200 seconden."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-008",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 1,5 uur?",
      "options": ["90 minuten", "150 minuten", "15 minuten", "105 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_decimal_hours_to_minutes",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Decimale uren naar minuten",
            "content": "1,5 uur = 1 uur en 30 minuten. Reken: 1 × 60 + 30 = 90 minuten. Of: 1,5 × 60 = 90 minuten. Onthoud: 0,5 uur = 30 minuten (de helft van 60).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "1,5 uur is hetzelfde als 1 uur en een half uur. Een half uur = 30 minuten. Dus: 1 uur (60 min) + 30 min = 90 minuten. Je kunt ook direct rekenen: 1,5 × 60 = 90 minuten. Controleer: 90 ÷ 60 = 1,5 uur ✓.",
        "solutionSteps": [
          "1,5 uur = 1 uur + 0,5 uur",
          "1 uur = 60 minuten, 0,5 uur = 30 minuten",
          "60 + 30 = 90 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! 1,5 × 60 = 90 minuten.",
          "1": "150 minuten is 2,5 uur (2,5 × 60 = 150). Voor 1,5 uur reken je 1,5 × 60 = 90 minuten.",
          "2": "Je hebt de komma weggelaten (1,5 → 15). Maar 1,5 uur = anderhalf uur = 90 minuten. Reken: 1,5 × 60 = 90.",
          "3": "Je hebt 1 uur en 45 minuten gerekend (60 + 45 = 105). Maar 0,5 uur = 30 minuten, niet 45. Reken: 1 × 60 + 30 = 90 minuten."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-009",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren zijn 450 minuten?",
      "options": ["7,5 uur", "4,5 uur", "45 uur", "75 uur"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_decimal_hours",
      "variantIndex": 9,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Minuten naar decimale uren",
            "content": "Deel door 60: 450 ÷ 60 = 7,5 uur. Of: 7 × 60 = 420, rest = 30 minuten = 0,5 uur. Dus 7,5 uur.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel de minuten door 60: 450 ÷ 60 = 7,5 uur. Je kunt het ook stap voor stap doen: 7 × 60 = 420 minuten (7 hele uren). Rest: 450 − 420 = 30 minuten. 30 minuten = 0,5 uur. Totaal: 7 + 0,5 = 7,5 uur. Controleer: 7,5 × 60 = 450 min ✓.",
        "solutionSteps": [
          "450 ÷ 60 = 7 hele uren (7 × 60 = 420)",
          "Rest: 450 − 420 = 30 minuten = 0,5 uur",
          "Totaal: 7 + 0,5 = 7,5 uur"
        ],
        "distractorExplanations": {
          "0": "Goed! 450 ÷ 60 = 7,5 uur.",
          "1": "4,5 uur = 270 minuten (4,5 × 60 = 270), niet 450. Reken: 450 ÷ 60 = 7,5 uur.",
          "2": "Je hebt de komma vergeten of door 10 gedeeld. 450 ÷ 60 = 7,5 uur, niet 45 uur.",
          "3": "Je hebt 450 ÷ 6 gerekend in plaats van 450 ÷ 60. Let op: 1 uur = 60 minuten. Reken: 450 ÷ 60 = 7,5 uur."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-010",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel uren en minuten zijn 500 minuten?",
      "options": ["8 uur en 20 minuten", "5 uur", "50 uur", "8 uur en 40 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_minutes_to_compound_large",
      "variantIndex": 10,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Grote aantallen minuten omzetten",
            "content": "Deel door 60: 500 ÷ 60 = 8 rest 20. Dus 8 uur en 20 minuten. Check: 8 × 60 = 480, en 500 − 480 = 20.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel 500 door 60. Hoeveel hele uren? 8 × 60 = 480 (past). 9 × 60 = 540 (past niet). Dus 8 hele uren. Rest: 500 − 480 = 20 minuten. Antwoord: 8 uur en 20 minuten. Controleer: 8 × 60 + 20 = 500 ✓.",
        "solutionSteps": [
          "8 × 60 = 480 (past), 9 × 60 = 540 (past niet)",
          "Rest: 500 − 480 = 20 minuten",
          "Antwoord: 8 uur en 20 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! 8 × 60 = 480, rest = 500 − 480 = 20 minuten.",
          "1": "5 uur = 300 minuten, niet 500. Je hebt waarschijnlijk 500 ÷ 100 = 5 gerekend. Maar 1 uur = 60 minuten. Reken: 500 ÷ 60 = 8 rest 20.",
          "2": "Je hebt de getallen van 500 gesplitst (50 en 0). Maar je moet delen door 60: 500 ÷ 60 = 8 uur en 20 minuten.",
          "3": "Je hebt de rest verkeerd berekend. 8 × 60 = 480. Rest = 500 − 480 = 20 minuten, niet 40. Controleer altijd je restberekening."
        }
      }
    },
    {
      "id": "TIJD-OMREKENEN-011",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "fill_in",
      "question": "Hoeveel minuten zijn 4 uur en 45 minuten? Typ het aantal minuten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["285"],
        "caseSensitive": false,
        "placeholder": "... minuten"
      },
      "conceptId": "time_compound_to_minutes_fill",
      "variantIndex": 11,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar minuten",
            "content": "Reken de uren om: 4 uur = 4 × 60 = 240 minuten. Tel de minuten erbij: 240 + 45 = 285 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Reken stap voor stap. De uren: 4 × 60 = 240 minuten. De losse minuten erbij: 240 + 45 = 285 minuten. Controleer: 285 ÷ 60 = 4 rest 45 → 4 uur 45 min ✓.",
        "solutionSteps": [
          "4 uur = 4 × 60 = 240 minuten",
          "240 + 45 = 285 minuten",
          "Controleer: 285 ÷ 60 = 4 rest 45 ✓"
        ]
      }
    },
    {
      "id": "TIJD-OMREKENEN-012",
      "familyId": "TIJD-OMREKENEN",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 8,
      "skill": "tijdrekenen",
      "subSkill": "tijd_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel seconden zijn 2 minuten en 45 seconden?",
      "options": ["165 seconden", "245 seconden", "105 seconden", "285 seconden"],
      "correctAnswer": 0,
      "conceptId": "time_compound_to_seconds_large",
      "variantIndex": 12,
      "citoDifficulty": 0.41,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Gemengde tijd naar seconden",
            "content": "Reken de minuten om: 2 minuten = 2 × 60 = 120 seconden. Tel de seconden erbij: 120 + 45 = 165 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Reken stap voor stap. De minuten: 2 × 60 = 120 seconden. De losse seconden erbij: 120 + 45 = 165 seconden. Controleer: 165 ÷ 60 = 2 rest 45 → 2 min 45 sec ✓.",
        "solutionSteps": [
          "2 minuten = 2 × 60 = 120 seconden",
          "120 + 45 = 165 seconden",
          "Controleer: 165 ÷ 60 = 2 rest 45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × 60 + 45 = 120 + 45 = 165 seconden.",
          "1": "Je hebt de getallen aan elkaar gezet (2 en 45 = 245). Maar je moet rekenen: 2 × 60 + 45 = 165 seconden.",
          "2": "Je hebt 1 × 60 + 45 = 105 gerekend. Maar het zijn 2 minuten, niet 1. Reken: 2 × 60 + 45 = 165 seconden.",
          "3": "Je hebt 4 × 60 + 45 = 285 gerekend. Maar het zijn 2 minuten, niet 4. Reken: 2 × 60 + 45 = 165 seconden."
        }
      }
    }
  ]
}